document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".variant-swatches-ajax").forEach(container => {
    const productHandle = container.getAttribute("data-handle");
    if (!productHandle) return;
    fetch(`/products/${productHandle}.js`)
      .then(response => response.json())
      .then(product => {
        console.log("Product variants for", productHandle, product.variants); // DEBUG
        if (product.variants.length <= 1) return;
        // let html = '<div class="variant-swatch-container">';
        let html = '<div class="variant-swatch-container" style="border: 2px solid red;">';
        product.variants.forEach(variant => {
          console.log("Variant:", variant); // DEBUG
          if (variant.featured_image) {
            html += `
              <img 
                src="${variant.featured_image.src}?width=64"
                alt="${variant.title}"
                class="variant-swatch"
              >
            `;
          } else {
            html += `
              <span class="variant-swatch-text">
                ${variant.title}
              </span>
            `;
          }
        });
        html += "</div>";
        container.innerHTML = html;
      })
      .catch(err => {
        console.error("Error fetching product data:", err);
      });
  });
});